export interface AppSpecs {
  'specs.abTranslate.marketing.templatesGallery.web.abSpec-titleStartCreating': '0' | '1';
  'specs.funnel.TemplatesGalleryEnableFilters': 'true' | 'false';
  'specs.cookieConsent.CcpHostsIntegration': 'true' | 'false';

  // FIXME: move the following specs to "marketing.templatesGallery.web" scope
  // Conducting in both API and SSR calls, but should only for App (SSR)
  'specs.funnel.CBDBannerAndSearchRedirect': 'true' | 'false';
  'specs.funnel.EnableZeroSearchAdiLinksInTemplatesGallery': 'true' | 'false';
  'specs.funnel.TemplatesGalleryDisableWixHeaderAndFooter': 'true' | 'false';
  'specs.funnel.TemplatesGalleryEnableWidget': 'Disabled' | 'OldWidget' | 'WithCover' | 'NoCover' | 'ColoredCover';
  'specs.funnel.TemplatesGalleryEnableWidgetForLoggedInUsers':
    | 'Disabled'
    | 'OldWidget'
    | 'WithCover'
    | 'NoCover'
    | 'ColoredCover';
  'specs.funnel.TemplatesGalleryForYouPage': 'true' | 'false';
  'specs.funnel.TemplatesGalleryV2NumericPagination': 'true' | 'false';
  'specs.funnel.UseMetaSiteCreator': 'true' | 'false';
  'specs.funnel.NewIntroEnableAppSuggestions': 'true' | 'false';
  'specs.marketing.CheckBlockerPopupOnEdit': 'true' | 'false';
  'specs.marketing.EnableAppsInstaller': 'true' | 'false';
  'specs.marketing.EnableTemplateVerticals': 'true' | 'false';
}

export const defaultAppSpecs: AppSpecs = {
  'specs.abTranslate.marketing.templatesGallery.web.abSpec-titleStartCreating': '0',
  'specs.funnel.TemplatesGalleryEnableFilters': 'false',
  'specs.cookieConsent.CcpHostsIntegration': 'false',

  // FIXME: move the following specs to "marketing.templatesGallery.web" scope
  // Conducting in both API and SSR calls, but should only for App (SSR)
  'specs.funnel.CBDBannerAndSearchRedirect': 'false',
  'specs.funnel.EnableZeroSearchAdiLinksInTemplatesGallery': 'false',
  'specs.funnel.TemplatesGalleryDisableWixHeaderAndFooter': 'false',
  'specs.funnel.TemplatesGalleryEnableWidget': 'Disabled',
  'specs.funnel.TemplatesGalleryEnableWidgetForLoggedInUsers': 'Disabled',
  'specs.funnel.TemplatesGalleryForYouPage': 'false',
  'specs.funnel.TemplatesGalleryV2NumericPagination': 'false',
  'specs.funnel.UseMetaSiteCreator': 'false',
  'specs.funnel.NewIntroEnableAppSuggestions': 'false',
  'specs.marketing.CheckBlockerPopupOnEdit': 'false',
  'specs.marketing.EnableAppsInstaller': 'false',
  'specs.marketing.EnableTemplateVerticals': 'false',
};
